<template>
  <div class="main-comparar-plano-form">
    <dados-proposta :active="1" />
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="comprar-plano-form">

            <transition name="fade">
              <div id="step-6" class="multi-step-form active-step" v-if="etapa === 'step-6'">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="backtoplanos()"
                      /></p>
                </div>
                <div class="d-flex align-content-center align-flex-title" style="margin-top: -58px"> 
                  <h3>{{ nome }}, precisamos de mais alguns dados</h3>
                </div>

                <div class="row" style="text-align: left;">
                  <b-col md="6" sm="12" style="padding-left: 0px;">
                    Sexo:
                  </b-col>
                  <b-col md="6" sm="12" class="btn-sexo-cadastro"> 
                    <b-button id="sexom" @click="changesexo($event)" :class="{ 'btn-clicked-dps' : sexo == 'Masculino' || sexo == String(1) }">Masculino</b-button>
                    <b-button id="sexof" @click="changesexo($event)" :class="{ 'btn-clicked-dps' : sexo == 'Feminino' || sexo == String(2) }">Feminino</b-button>
                  </b-col>
                </div>
                <!-- <div class="row" style="display: block; text-align: left">
                  <p>Com qual gênero você se identifica?</p>
                  <b-form-select v-model="generoTitular" :class="{ 'statusok-fontbold': generoTitular != null }">
                    <b-form-select-option :value="null">Selecione aqui</b-form-select-option>
                    <option value="masculino">Masculino</option>
                    <option value="feminino">Feminino</option>
                    <option value="homemtransgenero">Homem Transgênero</option>
                    <option value="mulhertransgenero">Mulher Transgênero</option>
                    <option value="homemtransexual">Homem Transexual</option>
                    <option value="mulhertransexual">Mulher Transexual</option>
                    <option value="cisgenero">Cisgênero</option>
                    <option value="outro">Não sei responder</option>
                  </b-form-select>
                </div> -->
                <div class="row" style="display: block; text-align: left">
                    <p>Nome da mãe:</p>
                    <b-form-input style="height:48px;" @keydown="onlyLetters($event)" v-model="nomemae" :formatter="formatter" placeholder="Informe aqui" :class="{ 'statusok-fontbold': nomemae.length > 2 && nomemae.indexOf(' ') > 0 }">
                    </b-form-input>
                    <img
                      v-if="nomemae.length > 2 && nomemae.indexOf(' ') > 0"
                      class="statusok-check"
                      src="../assets/statusok.svg"
                      alt="Check"
                    />
                </div>
                <div class="row" style="display: block; text-align: left">
                  <p>Estado civil:</p>
                  <b-form-select v-model="estadocivil" :options="options_estadocivil" :class="{ 'statusok-fontbold': estadocivil != null }" :style="[ estadocivil != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                    <b-form-select-option :value="null">Selecione aqui</b-form-select-option>
                  </b-form-select>
                </div>
                <div class="row" style="display: block; text-align: left">
                  <p>Documento:</p>
                  <b-form-select v-model="documentoTipo" :options="options_documentos" @change="checaDocumento()" :class="{ 'statusok-fontbold': documentoTipo != null }" :style="[ documentoTipo != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                    <b-form-select-option :value="null">Selecione um novo documento</b-form-select-option>
                  </b-form-select>
                </div>
                <div v-if="documentoTipo!==null" class="row" style="display: block; text-align: left">
                  <p>Número do documento</p>
                  <b-form-input v-if="documentoTipo==='001'" @keydown="onKeydown($event)" v-model="documentoNumero" placeholder="Digite aqui seu RG" :class="{ 'statusok-fontbold': documentoNumero.length > 0 }"></b-form-input>
                  <img
                    v-if="documentoTipo==='001' && documentoNumero.length > 0"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                  <b-form-input v-if="documentoTipo==='006'" @keydown="onKeydown($event)" v-model="documentoNumero" placeholder="Digite aqui seu CPF" :class="{ 'statusok-fontbold': documentoNumero.length > 0 }"></b-form-input>
                  <img
                    v-if="documentoTipo==='006' && documentoNumero.length > 0"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                  <b-form-input v-if="documentoTipo!=='006' && documentoTipo!=='001'" @keydown="onKeydown($event)" v-model="documentoNumero" placeholder="Digite aqui seu CPF" :class="{ 'statusok-fontbold': documentoNumero.length > 0 }"></b-form-input>
                  <img
                    v-if="documentoTipo!=='006' && documentoTipo!=='001' && documentoNumero.length > 0"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                </div>
                <div class="form-row" style="text-align: left; justify-content: space-between;">
                  <div class="form-group col-md-6">
                    <div>Orgão emissor do documento</div>
                    <b-form-select v-model="documentoOrgao" :class="{ 'statusok-fontbold': documentoOrgao != null }" :style="[ documentoOrgao != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                      <b-form-select-option :value="null" >Escolha aqui</b-form-select-option>
                      <option v-for="orgaoEmissor in orgaosEmissores" :key="orgaoEmissor.sigla">{{orgaoEmissor.sigla}} - {{orgaoEmissor.nome}}</option>
                    </b-form-select>
                  </div>
                  <div class="form-group col-md-2">
                    <div>UF:</div>
                    <b-form-select v-model="documentoUf" :class="{ 'statusok-fontbold': documentoUf != null }" :style="[ documentoUf != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                      <b-form-select-option :value="null">Estado</b-form-select-option>
                      <option v-for="estado in estados" :key="estado.sigla">{{estado.sigla}}</option>
                    </b-form-select>
                  </div>
                  <div class="form-group col-md-4">
                    <div>Data expedição:</div>
                    <div class="div-datepicker-nomargin"><date-picker 
                      v-model="documentoDtExpedicao"
                      v-mask="'##/##/####'"
                      valueType="format"
                      format="DD/MM/YYYY"
                      placeholder="Data de expedição"
                      :editable="true"
                      input-class="form-control add-datepicker"
                      :class="{
                        'statusok-fontbold-datepicker': documentoDtExpedicao.length > 9,
                      }"
                      :disabled-date="(date) => date > new Date() ? true : false"
                    ></date-picker></div>
                  </div>
                </div>
                <div class="form-row infoorgaoempresarial" style="text-align: left; justify-content: space-between;">
                  <div class="form-group col-md-6">
                    <div>Data de admissão do orgão:</div>
                    <div class="div-datepicker-nomargin"><date-picker 
                      v-model="dataAdmissaoOrgao"
                      v-mask="'##/##/####'"
                      valueType="format"
                      format="DD/MM/YYYY"
                      placeholder="Data de admissão"
                      :editable="true"
                      input-class="form-control"
                      :class="{
                        'statusok-fontbold-datepicker': dataAdmissaoOrgao.length > 9,
                      }"
                      :disabled-date="(date) => date > new Date() ? true : false"
                    ></date-picker></div>
                  </div>
                  <div class="form-group col-md-6">
                    <div>Matrícula/Registro na entidade:</div>
                    <b-form-input style="height:48px;" @keydown="onKeydown($event)" v-model="matricularegistroent" placeholder="Digite aqui o número" :class="{ 'statusok-fontbold': matricularegistroent.length > 6 }">
                    </b-form-input>
                    <img
                      v-if="matricularegistroent.length > 6"
                      class="statusok-check"
                      src="../assets/statusok.svg"
                      alt="Check"
                    />
                  </div>
                </div>
                <div v-if="orgaopublico && options_lotacao.length > 0" class="row" style="display: block; text-align: left">
                  <p>Lotação:</p>
                  <b-form-select v-model="lotacaoorgao" :options="options_lotacao" :class="{ 'statusok-fontbold': lotacaoorgao != null }" :style="[ lotacaoorgao != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                    <b-form-select-option :value="null">Selecione aqui</b-form-select-option>
                  </b-form-select>
                </div>
                <!-- TESTE VALIDAÇÃO -->
                <div v-if="errors.length"> 
                  <b v-for="erro in errors" :key="erro">{{ erro }}</b>                    
                </div> 
                <!-- TESTE VALIDAÇÃO -->

                <div class="row" style="margin-top: 100px">
                  <div class="btn-div" @click="setEtapa('step-6','step-7')">
                    <b-button class="btn-alianca btn-next btn-next-continuar-compra" :class="{ 'btn-clicked': documentoDtExpedicao !== '' }" :disabled="!documentoDtExpedicao">CONTINUAR COMPRA DO PLANO</b-button>
                    <b-button class="btn-alianca btn-next btn-icon-next" style="margin-left:-48px !important;" :class="{ 'btn-clicked-icon': documentoDtExpedicao !== '' }" :disabled="!documentoDtExpedicao"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                  </div>
                </div>
            </div>
            </transition>

            <transition name="fade">
            <div id="step-7" class="multi-step-form active-step" v-if="etapa==='step-8' && !respondeuPlanoAtivo">
              <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="respondeuPlanoAtivo = false,prevEtapa('step-7')"
                      /></p>
                </div>
                <div class="d-flex align-content-center align-flex-title" style="margin-top: -58px"> 
                  <h3>Têm plano de saúde ativo?</h3>
                </div>             
                <div style="margin-top: 40px;">
                  <b-button @click="respondeuPlanoAtivo = true" style="margin-left: 0" :class="{ 'btn-clicked-dps' : respondeuPlanoAtivo == true }">Sim</b-button>
                  <b-button @click="flagportabilidade = false; setEtapa('step-8', 'end')" :class="{ 'btn-clicked-dps' : flagportabilidade == false }">Não</b-button>
              </div>
             </div>    
            </transition>

            
            <transition name="fade">
              <div id="step-7" class="multi-step-form active-step" v-if="etapa==='step-8' && respondeuPlanoAtivo">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="respondeuPlanoAtivo = false,prevEtapa('step-7')"
                      /></p>
                </div>
                <div class="d-flex align-content-center align-flex-title mb-4" style="margin-top: -58px"> 
                  <h3>Deseja realizar a Portabilidade de Carência?</h3>
                </div>
                <div class="text-left">
                  <p>Portabilidade é a possibilidade de contratar um plano de saúde, dentro da mesma operadora ou com uma operadora diferente, e não precisar cumprir novos períodos de carência ou de Cobertura Parcial Temporária (CPT) exigíveis e já cumpridos no plano de origem.</p>
                  <p>A Portabilidade de carência estará sujeita
                  a analise técnica de acordo com as regras determinadas pela ANS.</p>
                </div>
                <div style="margin-top: 40px;">
                  <b-button @click="habilitaPortabilidade()" style="margin-left: 0" :class="{ 'btn-clicked-dps' : flagportabilidade == true }">Sim</b-button>
                  <b-button @click="flagportabilidade = false; setEtapa('step-8', 'end')" :class="{ 'btn-clicked-dps' : flagportabilidade == false }">Não</b-button>
                </div>    
                <div v-if="flagportabilidade" class="texto-portabilidade">
                  <p><b>Quais são os documentos necessários para solicitar a portabilidade?</b></p>
                  <div>
                    • Documentação que comprove elegibilidade de acordo com o tipo de portabilidade. Verifique os tipos no nosso <a style="color:#1DA090; text-decoration: underline;" href="https://aliancaadm.com.br/wp-content/uploads/2020/03/FAQ_portabilidade_Alianca.pdf" alt="Portabilidade" target="_blank">FAQ sobre Portabilidade.</a><br>
                    • Declaração de Portabilidade emitida pela Operadora ou administradora de origem.<br>
                    • Carta de tempo de permanência.<br>
                    • Cópia dos 3 últimos comprovantes de pagamentos<br>
                    • Cópia dos documentos (RG, CPF - ou certidão de nascimento para menores de idade e CPF).<br>
                    • Comprovante de endereço em nome do titular.<br>
                    • Pedido de mobilidade.<br>
                  </div>
                  <br>
                  <p><b>Quer saber se você pode solicitar portabilidade?</b></p>
                  <p>Consulte o nosso FAQ, acesse <a style="color:#1DA090; text-decoration: underline;" href="https://aliancaadm.com.br/portabilidade/" alt="Portabilidade" target="_blank">clicando aqui</a></p>
                </div>
                <div v-if="flagportabilidade" class="row" style="margin-top: 50px">
                  <div @click="setEtapa('step-8','end')">
                    <b-button class="btn-alianca btn-next btn-next-portabilidade btn-clicked">CONFIRMAR E CONTINUAR</b-button>
                    <b-button class="btn-alianca btn-next btn-icon-next btn-clicked-icon"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                  </div>
                </div>            
              </div>              
            </transition>

            <transition name="fade">
              <div id="step-8" class="multi-step-form active-step" v-if="etapa==='step-7'">                     
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="prevEtapa('step-6')"
                      /></p>
                </div>    
                <div class="d-flex align-content-center align-flex-title" style="margin-top: -58px"> 
                  <h3>Complete os dados dos seus dependentes</h3>
                  <!-- <h3>Você gostaria de adicionar um dependente ao plano?</h3> -->
                </div>                 
                <!-- <div style="margin-top: 50px;">
                  <b-button @click="habilitaFinalizacao(true)">Sim</b-button>
                  <b-button @click="habilitaFinalizacao(false)">Não</b-button>
                </div> -->
                <div id="incluirdep" style="display: block">
                  <!-- <div class="row row-insert-dependentes" style="text-align: left; margin-top: 80px; padding-bottom: 31px; border-bottom: 1px solid #E0E0E0;">
                    <b-col md="9" sm="6" style="padding-left: 0px;">
                      Quantidade de dependentes:
                    </b-col>
                    <b-col md="3" sm="6" style="display: flex; justify-content: space-between; padding-right: 0px;"> 
                      <button class="control-dep">
                        <img
                          src="../assets/remove-dep.svg"
                          @click.prevent="removerDependente()"
                        />
                      </button>
                      <span class="qtd-dep">{{ dependentes.length }}</span>
                      <button class="control-dep">
                        <img
                          src="../assets/add-dep.svg"
                          @click.prevent="adicionarDependente()"
                        />
                      </button>
                    </b-col>
                  </div> -->
                  <div class="dep-div div-modal-add-dep">
                    <span class="botao-modal-add-dep" v-b-modal.modal-add-dep>Adicionar/Remover dependente</span>
                    <b-modal id="modal-add-dep">
                      <template #modal-header="{ close }">
                        <div style="margin: 0">
                          <h5 class="title-modal">Adicionar ou remover <span style="color: #A01D22">dependentes</span></h5>
                        </div>
                        <div style="margin: 0">
                          <b-button class="close btn-close btn-modais-nohover" aria-label="Close" @click="close()">×</b-button>
                        </div>
                      </template>
                      <div class="conteudo-modal-add-dep">
                        <p>Prezado(a) Beneficiário(a),</p> 
                        <br>
                        <p>A adição ou remoção de dependentes implicará na alteração do valor do plano escolhido. Ao continuar, você será redirecionado novamente para a página de simulação, onde poderá adicionar ou remover um ou mais dependentes e, assim, escolher entre as novas opções de planos com os valores recalculados. </p>
                        <br>
                        <p>Tem certeza que deseja continuar?</p>
                      </div>
                      <template style="display: block" #modal-footer="{ close }">
                        <div @click="redirectGerenciar(); close()">
                          <b-button class="btn-alianca pesquisar-planos btn-next-dps">SIM</b-button>
                        </div>
                        <div>
                          <a
                            class="lgpd-semconsentimento"
                            href="#"
                            @click="close()"
                          >Não, continuar na mesma página</a>
                        </div>
                      </template>
                    </b-modal>
                  </div>
                  <div class="dep-div" v-for="(dependente, i) in dependentes" :key="i" style="margin: 0;">
                    <div class="row" style="margin-top:50px;">
                      <p style="
                        font-style: normal;
                        font-weight: bold;
                        font-size: 20px;
                        line-height: 26px;
                        letter-spacing: 0.1px;
                        color: #333333;
                      ">Dependente {{ i + 1 }}</p>
                    </div>
                    <div class="row" style="display: block; text-align: left; margin-top:20px;">
                      <p>Nome do dependente {{ i + 1 }}:</p>
                      <b-form-input v-model="dependente.NomeDep" @keydown="onlyLetters($event)" :formatter="formatter" placeholder="Digite o nome do dependente" :class="{ 'statusok-fontbold': dependente.NomeDep.length > 2 && dependente.NomeDep.indexOf(' ') > 0 }"></b-form-input>
                      <img
                        v-if="dependente.NomeDep.length > 2 && dependente.NomeDep.indexOf(' ') > 0"
                        class="statusok-check"
                        src="../assets/statusok.svg"
                        alt="Check"
                      />
                    </div>
                    <div class="row" style="display: block; text-align: left; margin-top:20px;">
                      <p>Grau de parentesco do dependente:</p>
                      <b-form-select v-model="dependente.GrauParentescoDep" :options="options_grauparentesco" :class="{ 'statusok-fontbold': dependente.GrauParentescoDep != null }">
                        <b-form-select-option :value="null">Selecione aqui</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="row" style="text-align: left; margin-top: 20px">
                      <b-col md="6" sm="12" style="padding-left: 0px;">
                        Sexo do dependente:
                      </b-col>
                      <b-col md="6" sm="12" class="btn-sexo-cadastro"> 
                        <b-button :id="'sexom-' + i" @click="changesexodep($event, i)" :class="{ 'btn-clicked-dps' : dependente.sexo == 'Masculino' || dependente.sexo == String(1) }">Masculino</b-button>
                        <b-button :id="'sexof-' + i" @click="changesexodep($event, i)" :class="{ 'btn-clicked-dps' : dependente.sexo == 'Feminino' || dependente.sexo == String(2) }">Feminino</b-button>
                      </b-col>
                    </div>
                    <div class="form-row" style="text-align: left; justify-content: space-between;">
                      <div class="form-group col-md-6" style="display: block; text-align: left">
                        <p>CPF do dependente:</p>
                        <b-form-input v-model="dependente.CPFDep" placeholder="Digite o CPF do dependente" v-mask="'###.###.###-##'" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': dependente.CPFDep.length > 13 }"></b-form-input>
                        <img
                          v-if="dependente.CPFDep.length > 13"
                          class="statusok-check"
                          src="../assets/statusok.svg"
                          alt="Check"
                        />
                      </div>
                      <div class="form-group col-md-6" style="display: block; text-align: left">
                        <p>Data de nascimento do dependente:</p>
                        <div class="div-datepicker-nomargin"><date-picker 
                          v-model="dependente.DataNascDep"
                          v-mask="'##/##/####'"
                          valueType="format"
                          format="DD/MM/YYYY"
                          placeholder="Data de nascimento"
                          :editable="true"
                          input-class="form-control"
                          :class="{
                            'statusok-fontbold-datepicker': dependente.DataNascDep.length > 9,
                          }"
                          :disabled-date="(date) => date > new Date() ? true : false"
                          :disabled="dependente.DataNascDep.length > 9"
                        ></date-picker></div>
                      </div>
                    </div>
                    <div class="row" style="display: block; text-align: left">
                      <p>Nome da mãe:</p>
                      <b-form-input style="height:48px;" @keydown="onlyLetters($event)" :formatter="formatter" v-model="dependente.nomemae" placeholder="Informe aqui" :class="{ 'statusok-fontbold': dependente.nomemae.length > 2 && dependente.nomemae.indexOf(' ') > 0 }">
                      </b-form-input>
                      <img
                        v-if="dependente.nomemae.length > 2 && dependente.nomemae.indexOf(' ') > 0"
                        class="statusok-check"
                        src="../assets/statusok.svg"
                        alt="Check"
                      />
                    </div>
                    <div class="row" style="display: block; text-align: left">
                      <p>Estado civil:</p>
                      <b-form-select v-model="dependente.estadocivil" :options="options_estadocivil" :class="{ 'statusok-fontbold': dependente.estadocivil != null }" :style="[ dependente.estadocivil != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                        <b-form-select-option :value="null">Selecione aqui</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="row" style="display: block; text-align: left">
                      <p>Documento:</p>
                      <b-form-select v-model="dependentes[i].documentoTipodep" :options="options_documentos" :class="{ 'statusok-fontbold': dependentes[i].documentoTipodep != null }" :style="[ dependentes[i].documentoTipodep != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"><!-- @change="checaDocumentodep(i)" -->
                        <b-form-select-option :value="null">Selecione um novo documento</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div v-if="dependentes[i].documentoTipodep!==null" class="row" style="display: block; text-align: left">
                      <p>Número do documento</p>
                      <b-form-input v-if="dependentes[i].documentoTipodep==='001'" @keydown="onKeydown($event)" v-model="dependentes[i].documentoNumerodep" placeholder="Digite aqui seu RG" :class="{ 'statusok-fontbold': dependentes[i].documentoNumerodep.length > 0 }"></b-form-input> <!-- @input="habilitaFinalizacao(false)" -->
                      <img
                        v-if="dependentes[i].documentoTipodep==='001' && dependentes[i].documentoNumerodep.length > 0"
                        class="statusok-check"
                        src="../assets/statusok.svg"
                        alt="Check"
                      />
                      <b-form-input v-if="dependentes[i].documentoTipodep!=='001'" @keydown="onKeydown($event)" v-model="dependentes[i].documentoNumerodep" placeholder="Digite aqui seu documento" :class="{ 'statusok-fontbold': dependentes[i].documentoNumerodep.length > 3 }"></b-form-input>
                      <img
                        v-if="dependentes[i].documentoTipodep!=='001' && dependentes[i].documentoNumerodep.length > 3"
                        class="statusok-check"
                        src="../assets/statusok.svg"
                        alt="Check"
                      />
                    </div>
                    <div class="form-row" style="text-align: left; justify-content: space-between;">
                      <div class="form-group col-md-6">
                        <div>Orgão emissor do documento</div>
                        <b-form-select v-model="dependente.documentoOrgao" :class="{ 'statusok-fontbold': dependente.documentoOrgao != null }" :style="[ dependente.documentoOrgao != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                          <b-form-select-option :value="null" >Escolha aqui</b-form-select-option>
                          <option v-for="orgaoEmissor in orgaosEmissores" :key="orgaoEmissor.sigla">{{orgaoEmissor.sigla}} - {{orgaoEmissor.nome}}</option>
                        </b-form-select>
                      </div>
                      <div class="form-group col-md-3">
                        <div>UF:</div>
                        <b-form-select v-model="dependente.documentoUf" :class="{ 'statusok-fontbold': dependente.documentoUf != null }" :style="[ dependente.documentoUf != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]">
                          <b-form-select-option :value="null">Estado</b-form-select-option>
                          <option v-for="estado in estados" :key="estado.sigla">{{estado.sigla}}</option>
                        </b-form-select>
                      </div>
                      <div class="form-group col-md-3">
                        <div>Data expedição:</div>
                        <div class="div-datepicker-nomargin"><date-picker 
                          v-model="dependente.documentoDtExpedicao"
                          v-mask="'##/##/####'"
                          valueType="format"
                          format="DD/MM/YYYY"
                          placeholder="Data de expedição"
                          :editable="true"
                          input-class="form-control"
                          :class="{
                            'statusok-fontbold-datepicker': dependente.documentoDtExpedicao.length > 9,
                          }"
                          :disabled-date="(date) => date > new Date() ? true : false"
                        ></date-picker></div>
                      </div>
                    </div>
                    <div class="row" style="display: block; text-align: left" v-if="showfield(dependente.DataNascDep)">
                      <p>Declaração de nascido vivo:</p>
                      <b-form-input maxlength="11" style="height:48px;" v-model="dependente.certidaonascidovivo" placeholder="Informe aqui" :class="{ 'statusok-fontbold': dependente.certidaonascidovivo.length > 2 }">
                      </b-form-input>
                      <img
                        v-if="dependente.certidaonascidovivo > 2"
                        class="statusok-check"
                        src="../assets/statusok.svg"
                        alt="Check"
                      />
                      <small><b-icon icon="exclamation-circle" style="margin-right: 5px; margin-top: -20px"></b-icon> Campo obrigatório apenas para nascidos a partir de 1º de Janeiro de 2010. O número pode ser encontrado na Certidão de Nascimento.</small>
                  </div>
                  </div>
                  <!-- <div class="row dep-btn-div" style="display: block">
                    <b-button @click="adicionarDependente()" style="width: 100%; margin-left: -1px; margin-top: 15px;">Adicionar dependente</b-button>
                  </div> -->
                  <!-- TESTE VALIDAÇÃO -->
                  <div v-if="errors.length"> 
                    <b v-for="erro in errors" :key="erro">{{ erro }}</b>                    
                  </div> 
                  <!-- TESTE VALIDAÇÃO -->
                </div>    
                <div class="row finaliza-dep aux-finaliza-dep" style="margin-top: 100px">
                  <div @click="setEtapa('step-7', 'step-8')">
                    <b-button class="btn-alianca btn-next btn-next-continuar-simule-nomargin" :class="{ 'btn-clicked': exibefinaliza === true }" :disabled="!exibefinaliza">CONFIRMAR E CONTINUAR</b-button>
                    <b-button class="btn-alianca btn-next btn-icon-next" :class="{ 'btn-clicked-icon': exibefinaliza === true }" :disabled="!exibefinaliza"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                  </div>
                </div>        
              </div>              
            </transition>
            
          </div>
        </div>
      </section>
    </main>

<div>
  <div class="modal-cancelamento">
  <b-modal id="bv-modal-example" hide-footer>
    <template #modal-title>
      {{tituloProposta}}
    </template>
    <div class="d-block text-center">
      <p v-html="mensagemProposta">
      </p>
    </div>
    <div v-if="statusBotao == 1" style="margin-left: 30%;">
      <b-button class="mt-3 botao-cancelamento" block @click="manterProposta()">Não</b-button>
      <b-button class="mt-3 botao-cancelamento" block @click="cancelarProposta()">Sim</b-button>
    </div>
    <div v-if="statusBotao == 2" style="margin-left: 39%;">
      <b-button class="mt-3 botao-cancelamento" block @click="manterProposta()">Acompanhar</b-button>
    </div>
    <div v-if="statusBotao == 3" style="margin-left: 39%;">
      <b-button class="mt-3 botao-cancelamento" block @click="manterProposta()">Painel de Serviços</b-button>
    </div>
  </b-modal>
  </div>
</div>    
  </div>
</template>

<style>

  /*.modal-dialog {
    max-width: 30%;
  }*/
/*  .modal-content{
    width: 100% !important;
  }*/
  .modal-body{
    margin-left: 0px;
    padding: 20px;
  }
  .botao-cancelamento{
    display: initial;
    width: 200px;
  }
  .botoes-cancelamento{
    margin-left: 30%;
  }
  
</style>

<script>
  import listarGrauParentesco from "../services/listarGrauDependentes"
  import listarTipoDocumentos from "../services/listarTipoDocumentos"
  import verificaProposta from "../services/verificaProposta"
  import cancelarPropostaAPI from "../services/cancelarPropostaAPI"
  import lerSetores from "../services/lerSetores"
  import textFormatter from "../utils/textFormatter";
  import store from "../store"
  import "vue2-datepicker/index.css"
  import "vue2-datepicker/locale/pt-br"

  export default {
    name: "Dados-beneficiario",
    data() {
      return {
        etapa: 'step-6',
        generoTitular: store.getters.getAliancaGeneroTitular,
        sexo: store.getters.getAliancaSexoTitular != null ? (store.getters.getAliancaSexoTitular == "1" ? "Masculino" : "Feminino") : '',
        nomemae: store.getters.getAliancaTitularNomeMae != null ? store.getters.getAliancaTitularNomeMae : '',
        estadocivil: store.getters.getAliancaTitularEstadoCivil,
        documentoTipo: store.getters.getAliancaDocumentoTipo,
        documentoNumero: store.getters.getAliancaDocumentoNumero != null ? store.getters.getAliancaDocumentoNumero : '',
        documentoOrgao: store.getters.getAliancaDocumentoOrgao,
        documentoUf: store.getters.getAliancaDocumentoUf,
        documentoDtExpedicao: store.getters.getAliancaDocumentoDtExpedicao != null ? store.getters.getAliancaDocumentoDtExpedicao : '',
        dataAdmissaoOrgao: store.getters.getAliancaTitularDataAdmissaoOrgao != null ? store.getters.getAliancaTitularDataAdmissaoOrgao : '',
        matricularegistroent: store.getters.getAliancaMatriculaRegOrgaoEntidade != null ? store.getters.getAliancaMatriculaRegOrgaoEntidade : '',
        lotacaoorgao: store.getters.getAliancaLotacaoOrgao,
        nome: store.getters.getAliancaNome,
        certidaonascidovivo: store.getters.getAliancaTitularCertidaoNascVivo,
        orgaoEmissor:'',
        estado: '',
        errors: [],
        dependentes: [],
        finalizaprocesso: false,
        exibefinaliza: false,
        flagportabilidade: store.getters.getAliancaFlagPortabilidade,
        datanasc: null,
        exibenascidovivo: false,
        options_grauparentesco: [],
        options_documentos: [],
        options_estadocivil: [
          { value: "S", text: "SOLTEIRO(A)" },
          { value: "C", text: "CASADO(A)" },
          { value: "V", text: "VIUVO(A)" },
          { value: "D", text: "DIVORCIADO(A)" },
          { value: "O", text: "OUTROS" }
        ],
        options_lotacao: [],
        opobrigacpf: null,
        opidademinobrigacpf: null,
        orgaopublico: false,
        respondeuPlanoAtivo: false,
        respostaProposta: false,
        propostas: [],
        operadoraProposta: '',
        statusProposta: [],
        mensagemProposta: '',
        tituloProposta: '',
        statusBotao: '',
      };
    },
    async mounted(){
      this.verificaPropostaAberta();
      if (this.$route.params.step) {
        this.dependentes = store.getters.getAliancaObjDependentes ? store.getters.getAliancaObjDependentes : []
        this.etapa = this.$route.params.step
        this.finalizaprocesso = true
        this.exibefinaliza = true
      }

      document.getElementById('step-progress').value = 69.69
      document.getElementById('step-progress-point1').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point2').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point3').classList.add("rounded-point-progress-ok")
      document.getElementById('globaletapa2').classList.remove("etapas-progresso-texto-disabled")
      document.getElementById('globaletapa3').classList.remove("etapas-progresso-texto-disabled")

      let grauparentesco = await listarGrauParentesco()
      for ( let i = 0; i < grauparentesco.length; i++ ) this.options_grauparentesco.push({ value: grauparentesco[i].BRP_CODIGO, text: grauparentesco[i].BRP_DESCRI })

      let tipodocumentos = await listarTipoDocumentos()
      for ( let i = 0; i < tipodocumentos.length; i++ ) this.options_documentos.push({ value: tipodocumentos[i].Z5_CHAVE, text: tipodocumentos[i].Z5_DESCRI })

      let setores = await lerSetores({
        idGrupoCobranca: store.getters.getAliancaNumeroContrato,
        subfat: store.getters.getAliancaSubFatura
      })
      for ( let i = 0; i < setores.length; i++ ) this.options_lotacao.push({ value: setores[i].ZC_CODIGO, text: setores[i].ZC_DESCRI })
    },
    created() {
      /*let objlogin = localStorage.getItem("AliancaObjLogin")
      if (objlogin != null){ */
        this.nome = store.getters.getAliancaNome.split(" ")[0]
        this.datanasc = store.getters.getAliancaDataNasc
        if ( this.showfield(this.datanasc) ) this.exibenascidovivo = true

        let estadosid_json = '[{"sigla": "AC", "codigo": 2183},{"sigla": "AL", "codigo": 2185},{"sigla": "AP", "codigo": 2187},{"sigla": "AM", "codigo": 2189},{"sigla": "BA", "codigo": 2191},{"sigla": "CE", "codigo": 2193},{"sigla": "DF", "codigo": 2195},{"sigla": "ES", "codigo": 2197},{"sigla": "GO", "codigo": 2199},{"sigla": "MA", "codigo": 2201},{"sigla": "MT", "codigo": 2203},{"sigla": "MS", "codigo": 2205},{"sigla": "MG", "codigo": 2207},{"sigla": "PR", "codigo": 2213},{"sigla": "PB", "codigo": 2211},{"sigla": "PA", "codigo": 2209},{"sigla": "PE", "codigo": 2215},{"sigla": "PI", "codigo": 2217},{"sigla": "RN", "codigo": 2221},{"sigla": "RS", "codigo": 2223},{"sigla": "RJ", "codigo": 2219},{"sigla": "RO", "codigo": 2225},{"sigla": "RR", "codigo": 2227},{"sigla": "SC", "codigo": 2229},{"sigla": "SE", "codigo": 2233},{"sigla": "SP", "codigo": 2231},{"sigla": "TO", "codigo": 2235}]'
        this.estados = JSON.parse(estadosid_json)

        let orgaoemissorid_json = '[{"sigla": "IIFP", "nome": "Instituto de Identificação Félix Pacheco"},{"sigla": "IPF", "nome": "Instituto Pereira Faustino"},{"sigla": "SSP", "nome": "Secretária de Segurança Pública"},{"sigla": "MA ", "nome": "Ministério da Aeronáutica"},{"sigla": "MM ", "nome": "Ministério da Marinha"},{"sigla": "MT ", "nome": "Ministério do Trabalho (para Carteira de Trabalho)"},{"sigla": "OAB", "nome": "Ordem dos Advogados do Brasil"},{"sigla": "CRE", "nome": "Conselho Regional de Engenharia e Arquitetura"},{"sigla": "CRM", "nome": "Conselho Regional de Medicina"},{"sigla": "CRA", "nome": "Conselho Regional de Administração"},{"sigla": "ME ", "nome": "Ministério do Exército"},{"sigla": "CBM", "nome": "Corpo de Bombeiros Militar"},{"sigla": "CRO", "nome": "Conselho Regional de Odontologia"},{"sigla": "CRF", "nome": "Conselho Regional de Farmácia"},{"sigla": "DETRAN", "nome": "Departamento Estadual de Trânsito"}, {"sigla": "RCPN", "nome": "Cartório Civil"}]'
        this.orgaosEmissores = JSON.parse(orgaoemissorid_json)

        let operadoras = store.getters.getAliancaPlanosOperadoras
        let operadora_plano_selecionado = store.getters.getAliancaSelectedPlano.frontoperadoraid.operadoraprotheusid
        let operadora = ""

        for (let el in operadoras) {
          if (el == operadora_plano_selecionado) {
            operadora = operadoras[el]
          } 
        }

        this.opobrigacpf = operadora.OBRIGA_CPF
        this.opidademinobrigacpf = parseInt(operadora.IDADE_MIN_CPF)

        let funcpublico = store.getters.getAliancaFuncPub
        if (funcpublico == 'Sim'){
          this.orgaopublico = true
        }
      /* } else {
        this.$router.push("cadastrar")
      } */
    },
    computed: {
      cpf(){
        let cpf = store.getters.getAliancaUsrCPF;
        let cpf2 = cpf.replace('.', '')
        let cpf3 = cpf2.replace('.', '')
        let cpf4 = cpf3.replace('-', '')
        console.log('cpf', cpf4)
        return cpf4;
      },
      libText(){
        // return directly html
        var str = this.mensagemProposta;
        return str;
      },
      SelectPlano(){
        let SelectPlano = store.getters.getAliancaSelectedPlano;
        return SelectPlano;
      },
    },
    methods: {
      async verificaPropostaAberta(){
        this.respostaProposta = await verificaProposta(this.cpf);
        if (this.respostaProposta.length > 0) {
          for (var i = this.respostaProposta.length - 1; i >= 0; i--) {
            this.propostas = this.respostaProposta[i].Z8_PROPOST
            this.statusProposta = this.respostaProposta[i].Z8_STATUS
            this.operadoraProposta = this.respostaProposta[i].Z8_CODEMP
          }

          if (
            this.statusProposta == "100" ||
            this.statusProposta == "150" ||
            this.statusProposta == "601" || 
            this.statusProposta == "602" || 
            this.statusProposta == "603" || 
            this.statusProposta == "701" || 
            this.statusProposta == "702" || 
            this.statusProposta == "703" || 
            this.statusProposta == "704" || 
            this.statusProposta == "705" 
          ) {
            this.tituloProposta = `Você possui outra contratação em andamento para a mesma operadora`;
            this.mensagemProposta = `Verificamos que você já possui uma outra <strong>contratação em andamento para a mesma operadora. Deseja cancelá-la para iniciar a contratação do novo plano escolhido</strong>? 
            <br><br>
            Caso não queira continuar a contratação do novo plano, você será redirecionado para o <strong>painel de serviço ao cliente</strong>. Ao fazer o login, clique na opção <strong>minhas propostas</strong> para consultar e acompanhar as suas outras contratações.`;
            this.statusBotao = 1;
          }

          if (
            this.statusProposta == "606" ||
            this.statusProposta == "608" ||
            this.statusProposta == "609" || 
            this.statusProposta == "401"
          ) {
            this.tituloProposta = `Você possui outra contratação em andamento para a mesma operadora `;
            this.mensagemProposta = `
            Para consultar e acompanhar as suas outras contratações, acesse o <strong>painel de serviço ao cliente</strong> e clique na opção <strong>minhas propostas</strong>. 
            <br><br>
            Você também pode consultar o andamento das suas contratações por meio da nossa central de vendas pelo <strong>Whatsapp: 11 3004-7009</strong>`;
            this.statusBotao = 2;
          }
          if (
            this.statusProposta == "900"
          ) {
            this.tituloProposta = `Você já possui um contrato ativo para a mesma operadora`;
            this.mensagemProposta = `
            Para consultar os dados do seu plano, 2ª via de boleto, solicitação de cancelamento e outros serviços, acesse o <strong>painel de serviço ao cliente</strong> clicando no botão abaixo. 
            <br><br>
            Você também pode entrar em contato conosco pelo <strong>Whatsapp: 11 3004-7009</strong>`;
            this.statusBotao = 3;
          }

          if (this.operadoraProposta == this.SelectPlano.codoperadora) {
            this.$bvModal.show('bv-modal-example')
          }
        }
      },
      manterProposta(){
        window.location.href = "https://svc.aliancaadm.com.br/aplicacoes/servicosonline/#homeacesseagora";
      },
      async cancelarProposta(){
        await cancelarPropostaAPI(this.propostas)
        this.$bvModal.hide('bv-modal-example')
      },
      onlyLetters(e){
        textFormatter.onlyLetters(e);
      },
      formatter(val){
        return val.toUpperCase();
      },
      redirectGerenciar(){
        document.getElementById('step-progress-point2').classList.remove("rounded-point-progress-ok")
        document.getElementById('step-progress-point3').classList.remove("rounded-point-progress-ok")
        document.getElementById('globaletapa2').classList.add("etapas-progresso-texto-disabled")
        document.getElementById('globaletapa3').classList.add("etapas-progresso-texto-disabled")
        this.$router.push('adicionar-dependentes')
      },
      showfield(data){
        let validadata = data.substr(6, 4)

        if (validadata >= '2010') return true  
        else return false 
      },
      changesexo(event){
          let id = event.currentTarget.id
          document.getElementById("sexom").classList.remove("btn-clicked-dps")
          document.getElementById("sexof").classList.remove("btn-clicked-dps")
          document.getElementById(id).classList.add("btn-clicked-dps")

          if (id == 'sexom') this.sexo = 'Masculino'
          else this.sexo = 'Feminino'
      },
      changesexodep(event, refer){
          let id = event.currentTarget.id
          document.getElementById("sexom-" + refer).classList.remove("btn-clicked-dps")
          document.getElementById("sexof-" + refer).classList.remove("btn-clicked-dps")
          document.getElementById(id).classList.add("btn-clicked-dps")

          let comparacaoid = id.replace( "-" + refer, "")
          if (comparacaoid == 'sexom') this.dependentes[refer].sexo = 'Masculino'
          else this.dependentes[refer].sexo = 'Feminino'
      },
      habilitaPortabilidade(){
        this.flagportabilidade = true
      },
      habilitaFinalizacao(){
        this.setEtapa('step-8','end')
      },
      checaDocumento(){
        this.documentoTipo === 'cpf' ? this.documentoNumero = store.getters.getAliancaUsrCPF : '' 
      },
      /* checaDocumentodep(i){
        this.dependentes[i].documentoTipo === 'cpf' ? this.dependentes[i].documentoNumero = localStorage.getItem('AliancaUsrCPF') : '' 
      }, */
      adicionarDependente(){
        this.dependentes.push({ NomeDep: '', CPFDep: '', GrauParentescoDep: null, DataNascDep: '', sexo: null, nomemae: '', estadocivil: null, documentoTipodep: null, documentoNumerodep: '', documentoOrgao: null, documentoUf: null, documentoDtExpedicao: '', certidaonascidovivo: '' })
      },
      removerDependente(){
        if (this.dependentes.length > 1) this.dependentes.pop()
      },
      onKeydown: function (e) {
        if (
          // permite somente numeros
          (e.keyCode >= 48 && e.keyCode <= 57) ||
          (e.keyCode >= 96 && e.keyCode <= 105) ||
          // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
          /^(8|9|13|46|37|39|17)$/.test(e.keyCode) ||
          // permite ctrl+ c,v,x,a,z
          (/^(67|86|88|65|90)$/.test(e.keyCode) && e.ctrlKey)
        )
          return;
        e.preventDefault();
        e.stopPropagation();
      },
      backtoplanos(){
        // localStorage.removeItem("AliancaObjLogin")
        this.$router.push("seu-plano")
      },
      prevEtapa(anterior) {
        this.etapa = anterior
      }, 
      validaAdicional(){
        /* if (fsSetor.Visible && ddlSetor.SelectedIndex == 0){
          this.errors.push('Informe a Lotação.')
          return false
        }
        if (ddlAtividade.SelectedIndex == 0){
          this.errors.push('Informe a principal atividade desenvolvida.')
          return false
        }
        if (!string.IsNullOrEmpty(txbPISPASEP.Text) && txbPISPASEP.Text.Length < txbPISPASEP.MaxLength){
          this.errors.push('Quantidade de dígitos insuficientes para PIS/PASEP.')
          return false
        }
        if (!string.IsNullOrEmpty(txbDeclaracaoNascidoVivo.Text) && txbDeclaracaoNascidoVivo.Text.Length < txbDeclaracaoNascidoVivo.MaxLength){
          this.errors.push('Quantidade de dígitos insuficientes para Dec. de Nasc. Vivo.')
          return false
        }
        if (!string.IsNullOrEmpty(txbCartaoNacionalSaude.Text) && txbCartaoNacionalSaude.Text.Length < txbCartaoNacionalSaude.MaxLength){
          this.errors.push('Quantidade de dígitos insuficientes para N° Cartão nacional de saúde.')
          return false
        }
        */

        return true
      },
      validaStep6(){
        this.errors = []

        /* if (!this.generoTitular) {
          this.errors.push('Selecione o gênero');
          return false;
        } */
        if (this.sexo == null) {
          this.errors.push('Selecione o sexo');
          return false;
        }
        if (this.nomemae.length < 2 || this.nomemae.indexOf(' ') == 0) {
          this.errors.push('Preencha o nome da mãe corretamente');
          return false;
        }
        if (!this.estadocivil) {
          this.errors.push('Selecione o estado civil');
          return false;
        }
        if (!this.documentoTipo) {
          this.errors.push('Selecione o tipo de documento');
          return false;
        }
        if (!this.documentoNumero) {
          this.errors.push('Preencha o número do documento');
          return false;
        }
        if (!this.documentoNumero.length) {
          this.errors.push('Número do documento incompleto');
          return false;
        }
        if (!this.documentoOrgao) {
          this.errors.push('Selecione o orgão emissor do documento');
          return false;
        }
        if (!this.documentoUf) {
          this.errors.push('Selecione o estado "UF"');
          return false;
        }
        if (this.documentoDtExpedicao.length > 0 && this.documentoDtExpedicao.length < 8 ) {
          this.errors.push('Data de expedição do documento incompleta');
          return false;
        }
        if (!this.documentoDtExpedicao) {
          this.errors.push('Preencha a data de expedição do documento');
          return false;
        }
        if ( this.orgaopublico ){

          if ( !this.lotacaoorgao && this.options_lotacao.length > 0 ){
            this.errors.push('Informe a lotação');
            return false;
          }
        }
        
        if (this.validaAdicional()) return true
        else return false
      },      
      validaStep7(){
        this.errors = []

        if (this.dependentes.length){
          let accerros = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          for ( let i = 0; i < this.dependentes.length; i++ ){
            if (!this.dependentes[i].NomeDep) accerros[0]++
            if (!this.dependentes[i].GrauParentescoDep) accerros[1]++
            if (this.dependentes[i].sexo == null) accerros[2]++
            if (this.opobrigacpf == 'S'){
              if (this.dependentes[i].DataNascDep){
                if (this.calculaIdadeDataformatada(this.dependentes[i].DataNascDep) > this.opidademinobrigacpf){
                  if (!this.dependentes[i].CPFDep) accerros[3]++
                  if (!this.TestaCPF(this.dependentes[i].CPFDep.replace('-','').replace('.', '').replace('.', ''))) accerros[16]++
                }
              }
            }
            if (this.dependentes[i].DataNascDep.length > 0 && this.dependentes[i].DataNascDep.length < 8 ) accerros[4]++
            if (!this.dependentes[i].DataNascDep) accerros[5]++
            if (this.dependentes[i].nomemae.length < 2 || this.nomemae.indexOf(' ') == 0) accerros[6]++
            if (!this.dependentes[i].estadocivil) accerros[7]++
            if (!this.dependentes[i].documentoTipodep) accerros[8]++
            if (!this.dependentes[i].documentoNumerodep) accerros[9]++
            // if (this.dependentes[i].documentoNumerodep.length > 0 && this.documentoNumerodep.length < 11 ) accerros[10]++
            if (!this.dependentes[i].documentoOrgao) accerros[11]++
            if (!this.dependentes[i].documentoUf) accerros[12]++
            if (this.dependentes[i].documentoDtExpedicao.length > 0 && this.documentoDtExpedicao.length < 8 ) accerros[13]++
            if (!this.dependentes[i].documentoDtExpedicao) accerros[14]++
            if (!this.dependentes[i].certidaonascidovivo && this.showfield(this.dependentes[i].DataNascDep)) accerros[15]++
          }

          if (accerros[0] > 0) {
            this.errors.push('Preencha o nome de todos os dependentes');
            return false;
          }
          if (accerros[1] > 0) {
            this.errors.push('Selecione o grau de parentesco de todos dependentes');
            return false;
          }
          if (accerros[2] > 0) {
            this.errors.push('Selecione o sexo de todos dependentes');
            return false;
          }          
          if (accerros[3] > 0) {
            this.errors.push('Preencha o CPF de todos os dependentes');
            return false;
          }
          if (accerros[4] > 0) {
            this.errors.push('Data de nascimento de algum dos dependentes está incompleta');
            return false;
          }
          if (accerros[5] > 0) {
            this.errors.push('Preencha a data de nascimento de todos dependentes');
            return false;
          }
          if (accerros[6] > 0) {
            this.errors.push('Preencha o nome da mãe de todos dependentes corretamente');
            return false;
          }
          if (accerros[7] > 0) {
            this.errors.push('Selecione o estado civil de todos dependentes');
            return false;
          }
          if (accerros[8] > 0) {
            this.errors.push('Selecione o tipo de documento de todos dependentes');
            return false;
          }
          if (accerros[9] > 0) {
            this.errors.push('Digite o documento de todos dependentes');
            return false;
          }
          if (accerros[11] > 0) {
            this.errors.push('Selecione o orgão emissor do documento de todos dependentes');
            return false;
          }
          if (accerros[12] > 0) {
            this.errors.push('Selecione o estado "UF" para todos dependentes');
            return false;
          }
          if (accerros[13] > 0) {
            this.errors.push('Verifique a data de expedição do documento dos dependentes');
            return false;
          }
          if (accerros[14] > 0) {
            this.errors.push('Preencha a data de expedição do documento de todos dependentes');
            return false;
          }
          if (accerros[15] > 0) {
            this.errors.push('Preencha a declaração de nascido vivo de todos os dependentes nascidos apartir de 2010');
            return false;
          }
          if (accerros[16] > 0) {
            this.errors.push('Informe CPFs válidos para todos dependentes');
            return false;
          }

          /*
          if (ddlParentesco.SelectedValue == "13" && idade > DateTime.Parse(proposta.BENEFICIARIOS[0].DATA_NASCIMENTO.FormataData()).retornaIdade()){
              this.errors.push('A data de nascimento deve ser menor que a do titular.');
          }
          if (ddlParentesco.SelectedValue == "11" && ((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS[0].ESTADO_CIVIL != "C"){
              this.errors.push('O estado civil do titular deve ser casado .');
          }
          if (ddlParentesco.SelectedValue == "11" && ((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS.FindAll(p => p.GRAU_PARENTESCO == "11").Count > 0){
              this.errors.push('Já existe um beneficiário com o grau parentesco cônjugue .');
          }
          if (ddlParentesco.SelectedValue == "11" && ddlEstadoCivil.SelectedValue.ToUpper() != "C"){
              this.errors.push('O estado civil deve ser casado .');
          }
          if (ddlParentesco.SelectedValue == "15" && idade > 18){
              this.errors.push('MENOR SOBRE GUARDA deve ter menos que 18 anos.');
          }
          if ((ddlParentesco.SelectedValue == "20" || ddlParentesco.SelectedValue == "16") && idade < DateTime.Parse(((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS[0].DATA_NASCIMENTO.FormataData()).retornaIdade()){
              this.errors.push('" + ddlParentesco.SelectedItem.Text + " deve ter idade maior que a do titular .');
          }
          if (ddlParentesco.SelectedValue == "17" && idade < 18){
              this.errors.push('" + ddlParentesco.SelectedItem.Text + " deve ter maior de 18 anos .');
          }
          */
        }

        return true;
      },  
      calculaIdadeDataformatada(data) {
        let currentDate = new Date();
        let birthDate = new Date(data.substr(6, 4), data.substr(3, 2), data.substr(0, 1));
        let difference = currentDate - birthDate;
        let age = Math.floor(difference / 31557600000);
        return age;
      }, 
      TestaCPF(strCPF) {
        let Soma
        let Resto
        Soma = 0
        if (strCPF == "00000000000") return false

        for ( let i = 1; i <= 9; i++ ) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i)
        Resto = (Soma * 10) % 11

        if ((Resto == 10) || (Resto == 11))  Resto = 0
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false

        Soma = 0;
        for ( let i = 1; i <= 10; i++ ) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
        Resto = (Soma * 10) % 11

        if ((Resto == 10) || (Resto == 11))  Resto = 0
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false
        return true
      },   
      async setEtapa(atual, prox) {
        switch (atual) {
          case "step-6":
            if (this.validaStep6()) {

              if (this.sexo == 'Masculino') this.sexo = "1"
              else this.sexo = "2"
              
              store.commit("mutAliancaGeneroTitular", this.generoTitular)
              store.commit("mutAliancaSexoTitular", this.sexo)
              store.commit("mutAliancaDocumentoTipo", this.documentoTipo)
              store.commit("mutAliancaDocumentoNumero", this.documentoNumero)
              store.commit("mutAliancaDocumentoOrgao", this.documentoOrgao)
              store.commit("mutAliancaDocumentoUf", this.documentoUf)
              store.commit("mutAliancaDocumentoDtExpedicao", this.documentoDtExpedicao)
              store.commit("mutAliancaTitularNomeMae", this.nomemae)
              store.commit("mutAliancaTitularEstadoCivil", this.estadocivil)
              store.commit("mutAliancaTitularDataAdmissaoOrgao", this.dataAdmissaoOrgao)
              store.commit("mutAliancaMatriculaRegOrgaoEntidade", this.matricularegistroent)
              store.commit("mutAliancaLotacaoOrgao", this.lotacaoorgao)
              store.commit("mutAliancaTitularCertidaoNascVivo", this.certidaonascidovivo)
              store.commit('mutAliancaProxEtapa', prox)
              this.etapa = prox
              document.getElementById('step-progress').value = 72.69
              
              this.dependentes = store.getters.getAliancaObjDependentes ? store.getters.getAliancaObjDependentes : []
              
              this.finalizaprocesso = true
              this.exibefinaliza = true
            }
            break
          case "step-7":
            if (this.validaStep7()) {
              store.commit("mutAliancaObjDependentes", this.dependentes)
              store.commit('mutAliancaProxEtapa', prox)
              this.etapa = prox;
              document.getElementById('step-progress').value = 78.69
            }
            break;
          case "step-8":
            store.commit("mutAliancaFlagPortabilidade", this.flagportabilidade)
            store.commit('mutAliancaProxEtapa', prox)
            if (store.getters.getAliancaObjDependentes != null){

              this.habilitaFinalizacao(true)

              // this.$router.push("declaracao-saude");
              // document.getElementById('step-progress').value = 78.69
            } else {
              this.habilitaFinalizacao(false)
            }

            this.etapa = prox;
            document.getElementById('step-progress').value = 75.69
            this.$router.push("declaracao-saude");

            break
        }
      },
    },
  };
</script>